const FilterDeadropSet = {
  filter: [
    'fuck',
    'fucker',
    'shit',
    'tits',
    'ass',
    'assholes',
    'dick',
    'homo',
    'bitch',
    'bitches',
    'boobs',
    'boobies',
    'gay',
    'gaysex',
    'bullshit',
    'founder',
    'DrDisrespect',
    'fourzerotwo',
    'Deez',
    'MidnightSociety',
    'MidniteSociety',
    'Variant',
    'Deadrop',
    'fourzerodos',
    'DrDlsrespect',
    'Dr_disrespect',
    'dr_dlsrespect',
    'disrespect',
    'doctordisrespect',
    'spacebob',
    'space_bob',
    'Midnight_society',
    'midnite_society',
    'Midnightprotocol',
  ],
}

export default FilterDeadropSet
